import React, { useEffect, useMemo, useState } from 'react';

import _ from 'lodash';

import Table, { IndeterminateCheckbox } from 'components/Table';

const SampleVideoTable = (props) => {
  const { data, setSort, sort, page, keyword, isFilter, onSelectVideo, originalVideoSelection, loading } = props;
  const [selectedRows, setSelectedRows] = useState([{ page: 1, selected: [] }]);

  const handleRowSelect = (rowSelect) => {
    try {
      setSelectedRows((prevSelected) => {
        // Get item index with page number
        const pageSelectedExists = _.findIndex(selectedRows, { page: page });
        const selectedRowWithPage = selectedRows.concat();

        // Create new object and push to array
        if (pageSelectedExists === -1) {
          return [
            ...prevSelected,
            {
              page: page,
              selected: [rowSelect?.original?.id],
            },
          ];
        }

        const rowIsSelected = selectedRowWithPage[pageSelectedExists]?.selected?.find((row) => row === rowSelect?.original?.id);

        /**
         * If you are select
         * - Delete the selected item from the array
         * - Delete all Object contains lines
         * - Add new object
         */
        if (rowIsSelected) {
          const selectedRemovedRow = selectedRowWithPage[pageSelectedExists].selected.filter((row) => row !== rowSelect.original.id);
          selectedRowWithPage.splice(pageSelectedExists, 1);
          selectedRowWithPage.push({
            page: page,
            selected: selectedRemovedRow,
          });
          return selectedRowWithPage;
        }

        const rowSelected = selectedRowWithPage[pageSelectedExists].selected;
        selectedRowWithPage.splice(pageSelectedExists, 1);
        selectedRowWithPage.push({
          page: page,
          selected: [...rowSelected, rowSelect.original.id],
        });
        return selectedRowWithPage;
      });
      rowSelect.getToggleSelectedHandler();
    } catch {
      // Handle error select
    }
  };

  const handleSelectAll = (table) => {
    try {
      setSelectedRows((prevState) => {
        const data = table.getRowModel().rows;
        const pageSelectedExists = _.findIndex(selectedRows, { page: page });
        const selectedRowWithPage = selectedRows.concat();

        if (pageSelectedExists === -1) {
          return [
            ...prevState,
            {
              page: page,
              selected: data?.map((row) => row?.original?.id),
            },
          ];
        }

        /**
         * If the Select of the page is currently in the Testhall (Condition) state
         * (Condition): Select length is equal to the number of non -public status items on the current page
         * then remove the whole object of that page to become Uncheck.
         */
        if (selectedRowWithPage[pageSelectedExists]?.selected?.length === data?.length) {
          selectedRowWithPage.splice(pageSelectedExists, 1);
          return selectedRowWithPage;
        }

        selectedRowWithPage.splice(pageSelectedExists, 1);
        selectedRowWithPage.push({
          page: page,
          selected: data.map((row) => row?.original?.id),
        });

        return selectedRowWithPage;
      });
    } catch {
      // Handle error select all
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: '-',
        header: ({ table }) => {
          const currentPageSelection = _.find(selectedRows, { page: page });
          const selectedCount = currentPageSelection?.selected?.length || 0;
          const tableRowsCount = table.getRowModel().rows?.length || 0;
          const isAllSelected = selectedCount === tableRowsCount && tableRowsCount > 0;

          return (
            <div className={`${data?.length <= 0 && '!cursor-not-allowed'} flex justify-center items-center w-4`}>
              <IndeterminateCheckbox
                className={`m-auto ${data?.length <= 0 && '!cursor-not-allowed'}`}
                {...{
                  checked: isAllSelected,
                  indeterminate: selectedCount > 0 && selectedCount < tableRowsCount,
                  onChange: () => handleSelectAll(table),
                }}
              />
            </div>
          );
        },
        size: 48,
        enableSorting: false,
        cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <IndeterminateCheckbox
                className={'m-auto'}
                {...{
                  checked: _.find(selectedRows, { page: page })?.selected?.some((item) => item === row?.original?.id),
                  indeterminate: false,
                  onChange: () => handleRowSelect(row),
                }}
              />
            </div>
          );
        },
      },
      {
        accessorKey: 'file_sample_name',
        header: ({ table }) => {
          setSort(table.getState().sorting);
          return <span>運動名</span>;
        },
        cell: ({ row, getValue }) => {
          const displayName = row.original?.name_vi || row.original?.name || getValue() || '-';
          return (
            <div className="flex-between-center text-sm gap-5">
              <span className={'break-all'}>{displayName}</span>
            </div>
          );
        },
        size: 350,
        sortingFn: () => {},
      },
      {
        accessorKey: 'explain',
        enableSorting: false,
        header: () => <span>運動動画説明</span>,
        cell: ({ row }) => {
          const explain = row.original.explain?.replace(/\n/g, '<br />').replace(/\r/g, '');
          return (
            <div className="flex-between-center text-sm gap-5">
              <span className="break-all" dangerouslySetInnerHTML={{ __html: explain }} />
            </div>
          );
        },
        size: 470,
      },
      {
        accessorKey: 'name',
        header: () => <span>運動カテゴリー</span>,
        cell: ({ row, getValue }) => {
          const displayCategory = row.original?.category?.name_vi || row.original?.category?.name || getValue() || '-';
          return (
            <div className="flex-between-center text-sm gap-5">
              <span className="break-all">{displayCategory}</span>
            </div>
          );
        },
        size: 350,
        enableSorting: false,
      },
      {
        accessorKey: '-',
        enableSorting: false,
        header: () => <span>ファイル名</span>,
        cell: ({ row }) => {
          return (
            <ul className="text-sm gap-5 list-disc">
              {row.original.file_samples.map((item, index) => (
                <li key={index} className="break-all mt-2">
                  {item.file_custom_url}
                </li>
              ))}
            </ul>
          );
        },
        size: 350,
      },
    ],
    [selectedRows, page]
  );

  useEffect(() => {
    setSelectedRows([]);
  }, [sort, keyword]);

  useEffect(() => {
    if (originalVideoSelection && originalVideoSelection.length > 0) {
      const dataCurrentPageExists = selectedRows.findIndex((item) => item.page === page);
      const newSelectedRows = _.cloneDeep(selectedRows);

      if (dataCurrentPageExists !== -1) {
        const dataIds = data.map((item) => item.id);
        newSelectedRows[dataCurrentPageExists].selected = [
          ...newSelectedRows[dataCurrentPageExists].selected,
          ...originalVideoSelection.filter((item) => dataIds.includes(item) && !newSelectedRows[dataCurrentPageExists].selected.includes(item)),
        ];
      } else {
        const dataIds = data.map((item) => item.id);
        newSelectedRows.push({ page: page, selected: originalVideoSelection.filter((item) => dataIds.includes(item)) });
      }

      setSelectedRows(newSelectedRows);
    }
  }, [originalVideoSelection, data]);

  useEffect(() => {
    onSelectVideo(selectedRows);
  }, [selectedRows]);

  return (
    <>
      <Table columns={columns} data={loading ? [] : data} isFilter={isFilter} isSampleVideoList={true} />
    </>
  );
};

export default React.memo(SampleVideoTable);
